import React, { Component } from 'react'
import './User.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { confirmAlert } from 'react-confirm-alert'
import Tree, { TreeNode } from 'rc-tree'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
import Api from '../../Api'
import 'react-confirm-alert/src/react-confirm-alert.css'
import ErrorAlert from '../Alerts/ErrorAlert'
import moment from 'moment'
import 'url-search-params-polyfill'
import AuthenticationService from '../Security/AuthenticationService'
import { setUserEmail } from '../../actions/headers'
import { connect } from 'react-redux'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { bindActionCreators } from 'redux'
import CommonLoader from '../Alerts/CommonLoader'
import { SaveUsers, sortActivity, getActivity } from '../../actions/users'
import { autoRegisterByEmailAddress } from '../../actions/actions'
import grayDesc from '../../images/gray-desc.jpg'
import grayAsc from '../../images/gray-asc.jpg'
import unsorted from '../../images/gray-unsorted.jpg'
import { checkAccess, getPermission } from '../../actions/permissions'
const _ = require('underscore')
class User extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      userEmail: null,
      firstName: null,
      lastName: null,
      isActive: 1,
      resetPassword: 0,
      isVerified: 1,
      userRole: null,
      uuids: [],
      showRemoveUser: null,
      isEdit: false,
      selectAll: false,
      deleteAlertTitle: 'Confirm to Delete',
      confirmDeleteMessage: 'Are you sure you want to remove this user?',
      deleteConfirm: 'Yes',
      deleteCancel: 'No',
      deleteSuceessMessage: 'User Deleted Successfully',
      deleteErrorMessage: 'Unable to delete group data',
      errorMessage: '',
      errors: '',
      stores: [],
      disableViewAs: false,
      showCommonLoader: false,
      Account_TOS_Agree: 0,
      isSuccess: false,
      isDeletedSuccess: false,
      Ascending: true,
      noStores: false
    }
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    let isAdmin = this.authService.isAdmin()
    this.state.isAdmin = isAdmin
    const params = new URLSearchParams(this.props.history.location.search)
    this.state.uuid = params.get('uuid') ? params.get('uuid') : null
    // props.getPermission()
  }

  componentWillMount () {
    this.state.showCommonLoader = true
    const params = new URLSearchParams(this.props.history.location.search)
    const uuid = params.get('uuid') ? params.get('uuid') : null
    this.props.getActivity(uuid, () => {})
    let urlRoles = Config.apiBaseUrl + CommonConstants.apiUrls.getUserRoles
    if (this.state.isAdmin || this.authService.isMasquerade()) {
      urlRoles += '?uuid=' + uuid
    }
    // call to be moved to action
    this.api.getData(urlRoles, data => {
      this.setState({ roles: data.data })
    })

    // To load the user details, if Edit (UUID)
    this.load(uuid, () => {
      if (uuid) {
        this.setState({ isEdit: true })
        // call to be moved to action
        let url = Config.apiBaseUrl + CommonConstants.apiUrls.getUser + '?uuId=' + uuid
        this.api.getData(url, data => {
          let userObject = data.data
          this.state.uuid = uuid
          this.state.userEmail = userObject.userEmail
          this.authService.setUserEmail(userObject.userEmail)
          this.props.setUserEmail(userObject.userEmail)
          this.state.firstName = userObject.firstName
          this.state.lastName = userObject.lastName
          this.state.resetPassword = userObject.resetPassword
          this.state.isVerified = userObject.isVerified
          this.state.isActive = userObject.isActive
          this.state.disableViewAs = (parseInt(userObject.isActive) === 1)
          this.state.userRole = userObject.userRole
          this.state.Account_TOS_Agree = userObject.Account_TOS_Agree
          let treeData = this.state.treeData
          this.state.user = data.data
          this.setState(this.state)
          if (treeData) {
            let keys = this.findMatchedIds(treeData, item => {
              return (
                item.Type === 'store' &&
                userObject.storeIds.indexOf(item.StoreUid.toString()) > -1
              )
            })

            let stores = this.findMatchedClassName(treeData, item => {
              return (item.Type === 'store' && _.contains(userObject.storeIds, item.StoreUid))
            })
            this.state.defaultCheckedKeys = keys.map(String)
            this.state.stores = stores
          }
          this.state.showCommonLoader = false
          this.setState(this.state)
        }
        )
      } else {
        this.state.showCommonLoader = false
        this.setState(this.state)
        this.setState({ isEdit: false })
      }
    })
    this.props.sortActivity({ 'sortBy': '', 'sortType': '' })
  }

  // This Function will fetch details of stores and groups
  load (uuid, callback) {
    // OLD URL
    // let url = Config.apiBaseUrl + CommonConstants.apiUrls.getGroupHierarchyTree + '?showDualLane=' + true
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getGroupHierarchyTree
    if (this.state.isAdmin || this.authService.isMasquerade()) {
      url += '?uuid=' + uuid
    }
    // get Tree hierarchy - stores and groups
    // call to be moved to action
    this.api.getData(url, data => {
      if (data.status) {
        this.state.noStores = (data.data.length === 0)
        if (data.data.length !== 0) {
          this.state.treeData = this.groupHierarchy(data.data, this.groupHierarchyCompleted)
          this.setState(this.state)
          callback()
        }
        //  this.state.showCommonLoader = false
        this.setState(this.state)
      } else {
        this.state.noStores = true
        //  this.state.showCommonLoader = false
        this.setState(this.state)
        callback()
      }
      // OLD Method
      // this.state.treeData = data.data
      // this.setState(this.state)
      // callback()
    })
  }

  groupHierarchyCompleted (data, instance) {
    // instance.state.showCommonLoader = false
    instance.state.treeData = data
    instance.setState(instance.state)
    let stores = instance.findMatchedClassName(data, item => {
      return item.Type === CommonConstants.Type.Store
    })
    instance.state.noStores = (stores.length === 0)
    instance.setState(instance.state)
  }

  groupHierarchy (data, callback) {
    const findstore = (item) => {
      if (item.Children && item.Children.length) {
        return item.Children.find(findstore)
      } else {
        return item.Type === 'store'
      }
    }
    const gourpHierarchydata = (data, level = 0, parent = null) => {
      return data.map(item => {
        if (item.Children && item.Children.length) {
          gourpHierarchydata(item.Children, level + 1, item)
          if (item['className'] !== 'show' && !item.Children.find(findstore)) {
            item['className'] = 'hide'
          }
        } else if ((item.Type === 'store' && parent != null) || item.className) {
          parent['className'] = 'show'
        } else {
          item['className'] = 'hide'
        }
        return item
      })
    }
    var result = gourpHierarchydata(data)
    callback(result, this)
  }

  // On check of check box device Id will be noted
  onCheck (checkedKeys, node) {
    this.state.defaultCheckedKeys = checkedKeys
    this.state.stores = _.pluck(_.where(_.pluck(node.checkedNodes, 'props'), { type: 'store' }), 'className')
    let deviceUIds = _.pluck(_.where(_.pluck(node.checkedNodes, 'props'), { type: 'store' }), 'value')
    this.state.deviceUIds = deviceUIds
    this.setState(this.state)
  }
  renderRemoveButton () {
    // rendering the remove button based on the RemoveUser Permission and Edit.
    if (checkAccess(CommonConstants.userPermissions.RemoveUser) && this.state.isEdit) {
      return (
        <div>
          &nbsp;|&nbsp;<a className='cancel_butt' id='remove' onClick={() => { this.deleteUser() }} >{t[this.state.currentLanguage].removeuser}</a>
        </div>
      )
    } else {
      return ''
    }
  }
  renderSaveCancelButton () {
    let flag = false
    if (this.state.isEdit) {
      flag = checkAccess(CommonConstants.userPermissions.EditUser)
    } else {
      flag = checkAccess(CommonConstants.userPermissions.AddUser)
    }
    //console.log('this.state.isEdit', this.state.isEdit)
    // rendering the save and cancel button based on the AddUser, EditUser Permission.
    const language = this.state.currentLanguage
    if (flag) {
      return (
        <div>
          <table>
            <tbody>
              <tr>
                <td>
                  <input type='button' value={t[language].save} onClick={() => { this.submit() }} />
                </td>
                <td>
                    &nbsp;|&nbsp;<a className='cancel_butt' onClick={() => { this.clearUser() }} >{t[language].cancel}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    } else {
      return (<div />)
    }
  }
  // Handling the add/update user successMessage.
  handleSuccessMessage () {
    const language = this.state.currentLanguage
    return (
      <div className='successMessage'>
        <h4 style={{ color: '#009933' }}>{t[language].recordsaved}</h4>
        {/* Handling the willrecieveemail message if the user is adding a new user. */}
        {!this.state.isEdit ? <p style={{ 'font-size': '18px' }}>
          <span style={{ color: 'black' }}> {t[language].theuser} </span>
          <span style={{ color: '#009933' }}> {this.state.userEmail} </span>
          <span style={{ color: 'black' }}>{t[language].willrecieveemail}</span>
        </p> : '' }
      </div>
    )
  }
  render () {
    const language = this.state.currentLanguage
    const user = this.state
    const loop = (data, level = 0) => {
      if (data) {
        return data.map(item => {
          if (item.Children && item.Children.length) {
            return (
              <TreeNode title={this.renderStoresAndBrand(item, level)} className={item.StoreUid + ' ' + item.className} key={item.Id} value={item.Type === CommonConstants.Type.Store ? item.StoreUid : null} type={item.Type} groupId={item.Id}>
                {loop(item.Children)}
              </TreeNode>
            )
          } else {
            if (item.Type === 'store') {
              return <TreeNode title={this.renderStoresAndBrand(item, level)} className={item.StoreUid} key={item.Id} value={item.Type === CommonConstants.Type.Store ? item.DeviceUID : null} type={item.Type} groupId={item.Id} />
            } else {
              return <TreeNode title={this.renderStoresAndBrand(item, level)} className={item.className ? item.className : ''} key={item.Id} value={item.Type === CommonConstants.Type.Store ? item.DeviceUID : null} type={item.Type} groupId={item.Id} />
            }
          }
          // OLD Method
          // return <TreeNode title={this.renderStoresAndBrand(item, level)} className={(item.Name ? (item.StoreUid + '-' + item.Name) : item.StoreUid) + ' ' + item.className} key={item.Id} value={item.Type === CommonConstants.Type.Store ? item.StoreUid : null} type={item.Type} groupId={item.Id}/>
        })
      } else {
        return null
      }
    }
    return (<section className='editUser'>
      <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
      {/* This condition will handle the different success message for adding, updating and deleting the user. */}
      <div className={'successMessage ' + (this.state.isSuccess ? 'show' : 'hide')}>
        {this.state.isDeletedSuccess ? <h4 style={{ color: '#009933' }}>{t[language].recordDeleted}</h4> : this.handleSuccessMessage()}
      </div>
      <div className={this.state.showCommonLoader || this.state.isSuccess ? 'hide' : 'show'}>
        <div className='userDetails'>
          <div className='col1'>
            <div className='forms clear'>
              <div className='row content-middle'>
                <h3 className='col-xs-6'>{t[language].userdetails}</h3>
                <div className='col-xs-6 content-end'>{this.renderViewAs()}</div>
              </div>
              <ErrorAlert errorMessage={this.state.errorMessage} errors={this.state.errors} />
              <form className='row' onSubmit={() => { this.submit() }} >
                <div className='col-xs-12 col-md-6'>
                  <table className='user_form'>
                    <tbody>
                      <tr className='userDetailsRows'>
                        <th className='block'><label>{t[language].usernameemail} <span className='req' /></label></th>
                        <td className='block'><input type='text' name='userEmail' value={user.userEmail} onChange={(e) => { this.handleOnChange(e) }} /></td>
                        <td>
                          {this.renderRemoveButton()}
                        </td>
                      </tr>
                      <tr>
                        <th className='block'><label>{t[language].firstname} <span className='req' /></label></th>
                        <td className='block'><input type='text' maxLength='100' name='firstName' value={user.firstName} onChange={(e) => { this.handleOnChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='block'><label>{t[language].lastname} <span className='req' /></label></th>
                        <td className='block'><input type='text' maxLength='100' name='lastName' value={user.lastName} onChange={(e) => { this.handleOnChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='block'><label>{t[language].status} <span className='req' /></label></th>
                        <td className='block userStatus'>
                          <input type='radio' name='isActive' value={1} checked={this.state.isActive === 1} onClick={(e) => { this.handleRadioChange(e) }} />
                          <span id='active_inactive' className='statusText'><span>{t[language].Active}</span>&nbsp;&nbsp;</span>
                          <input type='radio' name='isActive' value={0} checked={this.state.isActive === 0} onClick={(e) => { this.handleRadioChange(e) }} /><span className='statusText'>{t[language].Inactive}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='col-xs-12 col-md-6 content-end remove-end'>
                  <table className='user_form'>
                    <tbody>
                      <tr>
                        <th className='block'><label>{t[language].userAccessLevel} <span className='req' /></label></th>
                        <td className='block'>
                          <select name='userRole' className='wide_select' value={this.state.userRole} onChange={(e) => { this.handleOnChange(e) }}>
                            <option value='' selected={!this.state.userRole} />
                            {this.renderOptions()}
                          </select>
                        </td>
                      </tr>
                      <tr className='block' >
                        <th className='multi_select block'>
                          <div className=''><span><label>{t[language].storeaccess}</label></span></div>
                          <div><span className='select_all'>{t[language].selectallapply}</span></div></th>
                        <td>
                          <div className='form_cbox'>
                            <Tree
                              className='myCls'
                              showIcon={false}
                              showLine
                              checkable
                              selectable={false}
                              defaultSelectedKeys={this.state.defaultSelectedKeys}
                              defaultCheckedKeys={this.state.defaultCheckedKeys}
                              onSelect={this.onSelect}
                              onCheck={this.onCheck.bind(this)}
                              checkedKeys={this.state.defaultCheckedKeys}
                            >
                              {loop(this.state.treeData)}
                            </Tree>

                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th className='block' />
                        <td className='block' colSpan='6'>
                          <div className='select_deselect'><a onClick={() => { this.selectAll() }} className='cancel_butt' id='select'>{t[language].selectall}</a><span>&nbsp;|&nbsp;</span>
                            <a className='cancel_butt' onClick={() => { this.deSelectAll() }} id='select-none'>{t[language].deselectall}</a></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='col-xs-12'>
                  {this.renderSaveCancelButton()}
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className={'ctable ' + (this.state.isAdmin ? 'show' : 'hidden')}>
          <div className='users listingAdmin'>
            <div className='activityLog'> User Activity Log </div>
            <div className='ctable'>
              <Table>
                <Thead>
                  <Tr className='theader'>
                    <Th className='fixedHeader'>
                      <div onClick={this.sortActivity.bind(this, 'lastLogin')} className='activityHeader'><div id='lastLogin'>Date/Time</div> <div><img src={(this.props.users.sortParamsActivity.sortBy === 'lastLogin' ? (this.props.users.sortParamsActivity.sortType === 'ASC' ? grayAsc : grayDesc) : unsorted)} alt='sort icon' /> </div> </div>
                    </Th>
                    <Th className='fixedHeader'>
                      <div onClick={this.sortActivity.bind(this, 'page')} className='activityHeader'><div>Page</div> <div><img src={(this.props.users.sortParamsActivity.sortBy === 'page' ? (this.props.users.sortParamsActivity.sortType === 'ASC' ? grayAsc : grayDesc) : unsorted)} alt='sort icon' /></div> </div>
                    </Th>
                    <Th className='fixedHeader'>
                      <div onClick={this.sortActivity.bind(this, 'action')} className='activityHeader'><div>Action</div> <div><img src={(this.props.users.sortParamsActivity.sortBy === 'action' ? (this.props.users.sortParamsActivity.sortType === 'ASC' ? grayAsc : grayDesc) : unsorted)} alt='sort icon' /></div> </div>
                    </Th>
                    <Th>
                      <div onClick={this.sortActivity.bind(this, 'record')} className='activityHeader'><div>Record</div><div> <img src={(this.props.users.sortParamsActivity.sortBy === 'record' ? (this.props.users.sortParamsActivity.sortType === 'ASC' ? grayAsc : grayDesc) : unsorted)} alt='sort icon' /> </div></div>
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {this.renderAudit()}
                </Tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </section>)
  }

  // Render 'view as' button, if user has reset his password, active, verified his account and aggreed to accounts terms and conditions
  renderViewAs () {
    const language = this.state.currentLanguage
    let lsData = JSON.parse(this.authService.getViewingAsOwner('ViewingAsOwner')) || null
    let userEmail = ''
    let owner = 0
    if (lsData) {
      owner = lsData.isOwner
      userEmail = lsData.userEmail
    } else {
      userEmail = this.state.userEmail
    }
    if (this.state.isAdmin && this.state.disableViewAs && parseInt(this.state.isVerified) === 1 && parseInt(this.state.resetPassword) === 0 && parseInt(this.state.Account_TOS_Agree) === 1) {
      return (<div className='viewing_as view-as-user'>
        <span>
          {owner === 1 ? t[language].currentlyviewingasUserAccountOwner : t[language].currentlyviewingasUser}
          <a onClick={(e) => { this.masquerade(e) }}>
            <div><span>{userEmail}</span></div>
          </a>
        </span>
      </div>)
    } else {
      return (<div />)
    }
  }

  // Render role options for dropdown
  renderOptions () {
    let roles = this.state.roles
    if (roles) {
      let roleOptions = roles.map(function (role, index) {
        if (role.Role_IsDefault === 1) {
          this.state.userRole = role.Role_UID
          this.setState(this.state)
        }
        return (<option key={index} value={role.Role_UID} selected={(role.Role_IsDefault === 1)} >{role.Role_Name}</option>)
      })
      return roleOptions
    }
  }
  sortActivity (sortBy, e) {
    let sortType = this.state.Ascending ? 'DESC' : 'ASC'
    let sortParams = { 'sortBy': sortBy, 'sortType': sortType }
    this.state.Ascending = !this.state.Ascending
    this.setState(this.state)
    this.setState({ showCommonLoader: true })
    this.props.sortActivity(sortParams)
    let self = this
    this.props.getActivity(this.state.uuid, () => {
      self.setState({ showCommonLoader: false })
    })
  }
  // Audit table
  renderAudit () {
    let audits = this.props.users.activities
    const language = this.state.currentLanguage
    let self = this
    if (audits) {
      let roleOptions = audits.map(function (audit, index) {
        return (
          <Tr className='tdata clear'>
            <Td className='fixedHeader'>
              { audit.lastLogin ? (moment(audit.lastLogin).locale(language === 1 ? 'fr-ca' : 'en').format('MM/DD/YYYY - h:mm:ssA')) : '' }
            </Td>
            <Td className='fixedHeader'>{audit.page}</Td>
            <Td className='fixedHeader'>{audit.action}</Td>
            <Td className='posRel'>{self.renderRecord(audit)}</Td>
          </Tr>
        )
      })
      return roleOptions
    }
  }

  // this function removes token from audit table, needs to be removed later point of time, when application is completely moved to React
  removeQuery (keyName, record) {
    var index = record.indexOf(keyName)
    if (index > -1) {
      return record.substring(0, index)
    }
    return record
  }

  // this function removes token from audit table, needs to be removed later point of time, when application is completely moved to React
  renderRecord (audit) {
    let record = audit.record
    if (record) {
      record = this.removeQuery('token=', record)
      record = this.removeQuery('&token=', record)
      record = this.removeQuery('atoken=', record)
      record = this.removeQuery('&atoken=', record)
    }
    return (
      <span>
        {record.substring(0, 25) }
        <a className={'ellipse ' + (record.length > 25 ? '' : 'hide')} >
          ...
          <span className='tooltipCustomAdmin'>{record}</span>
        </a >
      </span>
    )
  }

  handleOnChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  clearUser () {
    let url = (window.location.pathname.indexOf('/admin') === -1) ? '/settings/users' : '/admin/settings/users'
    this.authService.clearUUID()
    this.authService.clearUserEmail()
    window.location.href = url
  }

  handleRadioChange (e) {
    this.state.isActive = this.state.isActive === 1 ? 0 : 1
    this.setState(this.state)
  }

  // renderStoresAndBrand (item) {
  //   return (<div className='storeTree'><span className='StoreTitile'>{item.Name ? (item.StoreNumber ? item.StoreNumber + '-' : '') + item.Name : item.StoreNumber ? item.StoreNumber : ''}</span> <span className='StoreBrand'>{item.Brand ? item.Brand : ''}</span> </div>)
  // }

  renderStoresAndBrand (item, level) {
    return (<div className={'storeTree level-' + level}><span className={'StoreTitile level-' + level} >{item.Name ? (item.StoreNumber ? item.StoreNumber + '-' : '') + item.Name : item.StoreNumber ? item.StoreNumber : ''}</span> <span className='StoreBrand'>{item.Brand ? item.Brand : ''}</span> </div>)
  }

  // select all for stores and groups
  selectAll (e) {
    if (!this.state.selectAll) {
      this.setState({
        defaultCheckedKeys: _.pluck(this.state.treeData, 'Id').map(String),
        stores: this.findMatchedClassName(this.state.treeData, item => {
          return item.Type === 'store'
        }),
        selectedList: this.findMatchedIds(this.state.treeData, item => {
          return true
        }),
        deviceUIds: this.findMatchedIds(this.state.treeData, item => {
          return item.Type === 'store'
        })
      })
      this.setState({
        selectAll: true
      })
    }
  }

  // deselecting, selected groups and stores
  deSelectAll (e) {
    this.setState({
      defaultCheckedKeys: [],
      selectedList: [],
      stores: []
    })
    this.setState({
      selectAll: false
    })
    // }
  }

  findMatchedClassName (list, keys) {
    let selectedItems = []
    let selectedList = []
    let findStore = function (items) {
      items.map(item => {
        if (item.Children && item.Children.length) {
          findStore(item.Children)
        }
        if (keys(item)) {
          selectedItems.push(item.StoreUid)
          selectedList.push(item.Id)
        }
      })
    }

    findStore(list)
    this.setState({
      selectedList: selectedList
    })
    return selectedItems
  }

  findMatchedIds (list, keys) {
    let selectedList = []
    let findStore = function (items) {
      items.map(item => {
        if (item.Children && item.Children.length) {
          findStore(item.Children)
        }
        if (keys(item)) {
          selectedList.push(item.Id)
        }
      })
    }

    findStore(list)
    return selectedList
  }

  // remove user confirm alert popup
  deleteUser () {
    confirmAlert({
      title: t[this.state.currentLanguage]['confirmToDelete'],
      message: t[this.state.currentLanguage]['areyousureremoveuser'],
      buttons: [
        {
          label: t[this.state.currentLanguage]['yes'],
          onClick: () => {
            this.confirmDelete()
          }
        },
        {
          label: t[this.state.currentLanguage]['no'],
          onClick: () => { }
        }
      ]
    })
  }

  // remove user after confirmation
  confirmDelete () {
    this.state.showCommonLoader = true
    this.setState(this.state)
    if (this.state.isEdit && this.state.user.uuId) {
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.deleteUser + '?uuId=' + this.state.user.uuId
      this.api.deleteData(url, data => {
        this.state.showCommonLoader = false
        this.setState(this.state)
        if (data) {
          this.setState({ isSuccess: true, isDeletedSuccess: true })
          // this.props.history.push('/message', data.key)
        } else {
          this.state.errorMessage = this.state.deleteErrorMessage
          this.state.successMessage = ''
          this.setState(this.state)
        }
      }, error => {
        this.state.errorMessage = error.message
        this.state.successMessage = ''
        this.setState(this.state)
      })
    }
  }

  masquerade (e) {
    let lsData = JSON.parse(this.authService.getViewingAsOwner('ViewingAsOwner')) || null
    let userEmail = null
    let userUid = null
    let CompanyType = null
    if (lsData) {
      userEmail = lsData.userEmail
      userUid = lsData.userUid
      CompanyType = lsData.CompanyType
    } else {
      userEmail = this.state.userEmail
    }
    const language = this.state.currentLanguage
    let userPostData = {
      username: userEmail
    }
    if (this.authService.getSelectedMenu() === 'accounts') {
      window.location.href = '/admin/account?' + 'type=' + CompanyType + '&uuid=' + userUid
    }
    let url = Config.authBaseUrl + Config.tokenPath
    this.api.postData(url, userPostData, data => {
      if (data === 'Unauthorized') {
        this.setState({ errorMessage: t[language].internalservererrorP1 })
      } else {
        if (data && data.accessToken) {
          window.localStorage.removeItem('user_email')
          this.authService.clearUUID()
          window.localStorage.setItem('ctx_token', data.accessToken)
          this.authService.setAdmin(false)
          window.location.href = '/welcome'
        }
      }
    })
  }

  submit (e) {
    this.state.showCommonLoader = true
    this.setState(this.state)
    let isError = false
    const language = this.state.currentLanguage
    let errors = []
    this.setState({ errors: errors })

    // validating inputs
    if (!this.state.firstName) {
      errors.push(t[language].pleasefillinfirstname)
      isError = true
    }
    if (!this.state.lastName) {
      errors.push(t[language].pleasefillinlastname)
      isError = true
    }
    if (!this.state.userEmail) {
      errors.push(t[language].emailinvalid)
      isError = true
    } else {
      let reg = /\S+@\S+\.\S+/
      if (!reg.test(this.state.userEmail)) {
        errors.push(t[language].emailinvalid)
        isError = true
      }
    }
    if (!this.state.userRole) {
      errors.push(t[language].pleaseassignrole)
      isError = true
    }

    this.setState(this.state)
    if (!isError) {
      let User = {}
      User = {
        'uuId': this.state.uuid ? this.state.uuid : null,
        'firstName': this.state.firstName,
        'lastName': this.state.lastName,
        'userEmail': this.state.userEmail,
        'isActive': this.state.isActive,
        'userRole': this.state.userRole,
        'storeIds': this.state.stores ? this.state.stores : [],
        'createdDateTime': moment().format('YYYY-MM-DD HH:mm:ss')
      }
      this.props.SaveUsers(User, (error, data) => {
        if (error) {
          this.state.showCommonLoader = false
          this.setState(this.state)
          console.log(error)
          this.state.errorMessage = 'ERROR'
          this.state.successMessage = ''
          this.setState(this.state)
        } else {
          this.state.showCommonLoader = false
          this.setState(this.state)
          if (data.status) {
            this.props.autoRegisterByEmailAddress(this.state.userEmail)
            this.setState({ isSuccess: true })
          } else if (!data.status) {
            let errors = []
            errors.push(t[language][data.key])
            this.setState({ errors: errors })
          }
        }
      })
    } else {
      this.state.showCommonLoader = false
      this.setState(this.state)
      this.setState({ errors: errors })
    }
  }
}
function mapStateToProps (state) {
  return {
    headers: state.headers,
    users: state.users
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      setUserEmail: setUserEmail,
      autoRegisterByEmailAddress,
      SaveUsers,
      sortActivity,
      getActivity,
      getPermission
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(User)



// WEBPACK FOOTER //
// ./src/components/User/User.js